
let api_base = 'http://localhost:3000'
if (__PRERELEASE__)
  api_base = 'https://api-stage.pluginseo.com'
else if (__RELEASE__)
  api_base = 'https://api.pluginseo.com'
export const API_BASE = api_base

let www_base = 'http://www.pluginseo.local:3000'
if (__PRERELEASE__)
  www_base = 'https://www-stage.pluginseo.com'
else if (__RELEASE__)
  www_base = 'https://www.pluginseo.com'
export const WWW_BASE = www_base

export const APP_NAME = 'Plug in SEO'
export const SUPPORT_EMAIL = 'help@pluginseo.com'
export const COMPANY_NAME = 'Plug in Useful'

export const validations = {
  email: 'Please enter valid email address',
  url:   'Please enter valid url',
  equal: (a, b) => `${a} does not match the ${b}`,
}

export const SUPPORT_URL = 'https://plug-in-useful.typeform.com/to/DLDifh'
export const GOOGLE_OAUTH2_PATH = '/auth/google_oauth2'
export const GOOGLE_SEARCH_CONSOLE_VERIFY_BASE_URI = "https://search.google.com/search-console/ownership?resource_id="
export const GOOGLE_SEARCH_CONSOLE_PERMISSION_UNVERIFIED = "siteUnverifiedUser"
export const GOOGLE_SEARCH_CONSOLE_SETUP_URL = "https://search.google.com/search-console/about"
export const SEO_SERVICES_PATH = '/v2ui/seo_services'
export const UI_MIGRATION_PATH = '/v3ui/migration/up'



// WEBPACK FOOTER //
// ./app/consts.js